import { render, staticRenderFns } from "./return-item-request.vue?vue&type=template&id=501b22d0&"
import script from "./return-item-request.vue?vue&type=script&lang=js&"
export * from "./return-item-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports